"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Card = void 0;
var react_1 = __importDefault(require("react"));
var CoresIdentidadeMU_1 = __importDefault(require("../Cores/CoresIdentidadeMU"));
var Titulo_1 = require("../Tipografia/Titulo/Titulo");
var cardModule = require("./Card.module.scss");
var tituloPadrao = function (titulo) { return (react_1.default.createElement(Titulo_1.Titulo, { tipo: "cabecalho1", negrito: true, cor: CoresIdentidadeMU_1.default.azulEscuroMu }, titulo)); };
var tratarTitulo = function (titulo) {
    if (typeof titulo === "string") {
        return tituloPadrao(titulo);
    }
    else {
        return react_1.default.createElement(react_1.default.Fragment, null, titulo);
    }
};
var Card = function (_a) {
    var titulo = _a.titulo, _b = _a.corDeFundo, corDeFundo = _b === void 0 ? CoresIdentidadeMU_1.default.brancoMu : _b, corpo = _a.corpo, rodape = _a.rodape, style = _a.style, children = _a.children, styleChildren = _a.styleChildren, tituloNaMargem = _a.tituloNaMargem;
    return (react_1.default.createElement("div", { style: __assign({ backgroundColor: corDeFundo, position: "relative" }, style), className: "".concat(cardModule.card) },
        titulo && tituloNaMargem && (react_1.default.createElement("span", { style: {
                position: "absolute",
                top: "-0.5rem",
                left: "1rem",
                background: "white",
                padding: "0 0.5rem",
                // fontWeight: "bold",
            } }, titulo)),
        titulo && !tituloNaMargem && react_1.default.createElement("div", null, tratarTitulo(titulo)),
        react_1.default.createElement("div", { style: styleChildren }, children !== null && children !== void 0 ? children : corpo),
        rodape && (react_1.default.createElement("div", { className: "".concat(cardModule.cardRodape) }, rodape))));
};
exports.Card = Card;
